import colors from '@/utils/colors';

const {
  neutralColor,
} = colors;

export function getMetrics(options) {
  const { ibovespaResponse, categories, metricToCompare } = options;
  const metrics = [];
  const ibovespaDate = ibovespaResponse.map(stock => Number(stock.date));
  categories.forEach(i => {
    if (!ibovespaDate.includes(i)) {
      if (metricToCompare === 'volume') {
        metrics.push({ y: 0, color: neutralColor });
      } else if (metrics[0]) {
        metrics.push({
          y: metrics[metrics.length - 1].y,
        });
      } else {
        const beforeDateRange = ibovespaDate.filter(date => date < i);
        if (!ibovespaResponse[ibovespaDate.indexOf(Math.max(...beforeDateRange))]) {
          metrics.push({
            y: 0,
          });
        } else {
          metrics.push({
            y: ibovespaResponse[ibovespaDate.indexOf(Math.max(...beforeDateRange))][metricToCompare],
          });
        }
      }
    } else {
      metrics.push({
        y: ibovespaResponse[ibovespaDate.indexOf(i)][metricToCompare],
        color: ibovespaResponse[ibovespaDate.indexOf(i)].color,
        opacity: 0.3,
      });
    }
  });
  if (metricToCompare === 'price') {
    return metrics.map(metric => metric.y);
  }
  return metrics;
}

export const stocksList = [
  { name: 'A1MD34', symbol: 'A1MD34.SA' },
  { name: 'AALL34', symbol: 'AALL34.SA' },
  { name: 'AALR3', symbol: 'AALR3.SA' },
  { name: 'AAPL34', symbol: 'AAPL34.SA' },
  { name: 'ABBV34', symbol: 'ABBV34.SA' },
  { name: 'ABCB4', symbol: 'ABCB4.SA' },
  { name: 'ABCP11', symbol: 'ABCP11.SA' },
  { name: 'ABEV3', symbol: 'ABEV3.SA' },
  { name: 'ABTT34', symbol: 'ABTT34.SA' },
  { name: 'ACWI11', symbol: 'ACWI11.SA' },
  { name: 'ADBE34', symbol: 'ADBE34.SA' },
  { name: 'AERI3', symbol: 'AERI3.SA' },
  { name: 'AESB3', symbol: 'AESB3.SA' },
  { name: 'AFHI11', symbol: 'AFHI11.SA' },
  { name: 'AFLT3', symbol: 'AFLT3.SA' },
  { name: 'AGRO3', symbol: 'AGRO3.SA' },
  { name: 'AGXY3', symbol: 'AGXY3.SA' },
  { name: 'AIRB34', symbol: 'AIRB34.SA' },
  { name: 'ALLD3', symbol: 'ALLD3.SA' },
  { name: 'ALMI11', symbol: 'ALMI11.SA' },
  { name: 'ALPA3', symbol: 'ALPA3.SA' },
  { name: 'ALPA4', symbol: 'ALPA4.SA' },
  { name: 'ALPK3', symbol: 'ALPK3.SA' },
  { name: 'ALSO3', symbol: 'ALSO3.SA' },
  { name: 'ALUP11', symbol: 'ALUP11.SA' },
  { name: 'ALUP3', symbol: 'ALUP3.SA' },
  { name: 'ALUP4', symbol: 'ALUP4.SA' },
  { name: 'ALZR11', symbol: 'ALZR11.SA' },
  { name: 'AMAR3', symbol: 'AMAR3.SA' },
  { name: 'AMBP3', symbol: 'AMBP3.SA' },
  { name: 'AMER3', symbol: 'AMER3.SA' },
  { name: 'AMGN34', symbol: 'AMGN34.SA' },
  { name: 'AMZO34', symbol: 'AMZO34.SA' },
  { name: 'ANIM3', symbol: 'ANIM3.SA' },
  { name: 'APER3', symbol: 'APER3.SA' },
  { name: 'ARCT11', symbol: 'ARCT11.SA' },
  { name: 'ARML3', symbol: 'ARML3.SA' },
  { name: 'ARRI11', symbol: 'ARRI11.SA' },
  { name: 'ARZZ3', symbol: 'ARZZ3.SA' },
  { name: 'ASAI3', symbol: 'ASAI3.SA' },
  { name: 'ATOM3', symbol: 'ATOM3.SA' },
  { name: 'ATSA11', symbol: 'ATSA11.SA' },
  { name: 'ATTB34', symbol: 'ATTB34.SA' },
  { name: 'AURA33', symbol: 'AURA33.SA' },
  { name: 'AVGO34', symbol: 'AVGO34.SA' },
  { name: 'AVLL3', symbol: 'AVLL3.SA' },
  { name: 'AXPB34', symbol: 'AXPB34.SA' },
  { name: 'AZEV3', symbol: 'AZEV3.SA' },
  { name: 'AZEV4', symbol: 'AZEV4.SA' },
  { name: 'AZUL4', symbol: 'AZUL4.SA' },
  { name: 'B1NT34', symbol: 'B1NT34.SA' },
  { name: 'B3SA3', symbol: 'B3SA3.SA' },
  { name: 'BAAX39', symbol: 'BAAX39.SA' },
  { name: 'BABA34', symbol: 'BABA34.SA' },
  { name: 'BACW39', symbol: 'BACW39.SA' },
  { name: 'BAER39', symbol: 'BAER39.SA' },
  { name: 'BAHI3', symbol: 'BAHI3.SA' },
  { name: 'BALM4', symbol: 'BALM4.SA' },
  { name: 'BARI11', symbol: 'BARI11.SA' },
  { name: 'BAUH4', symbol: 'BAUH4.SA' },
  { name: 'BAZA3', symbol: 'BAZA3.SA' },
  { name: 'BBAS3', symbol: 'BBAS3.SA' },
  { name: 'BBDC3', symbol: 'BBDC3.SA' },
  { name: 'BBDC4', symbol: 'BBDC4.SA' },
  { name: 'BBFI11B', symbol: 'BBFI11B.SA' },
  { name: 'BBFO11', symbol: 'BBFO11.SA' },
  { name: 'BBOV11', symbol: 'BBOV11.SA' },
  { name: 'BBPO11', symbol: 'BBPO11.SA' },
  { name: 'BBRC11', symbol: 'BBRC11.SA' },
  { name: 'BBRK3', symbol: 'BBRK3.SA' },
  { name: 'BBSD11', symbol: 'BBSD11.SA' },
  { name: 'BBSE3', symbol: 'BBSE3.SA' },
  { name: 'BCFF11', symbol: 'BCFF11.SA' },
  { name: 'BCHI39', symbol: 'BCHI39.SA' },
  { name: 'BCIA11', symbol: 'BCIA11.SA' },
  { name: 'BCRI11', symbol: 'BCRI11.SA' },
  { name: 'BCSA34', symbol: 'BCSA34.SA' },
  { name: 'BCWV39', symbol: 'BCWV39.SA' },
  { name: 'BDLL4', symbol: 'BDLL4.SA' },
  { name: 'BDRX', symbol: 'BDRX.SA' },
  { name: 'BDVY39', symbol: 'BDVY39.SA' },
  { name: 'BEEF3', symbol: 'BEEF3.SA' },
  { name: 'BEEM39', symbol: 'BEEM39.SA' },
  { name: 'BEES3', symbol: 'BEES3.SA' },
  { name: 'BEES4', symbol: 'BEES4.SA' },
  { name: 'BEFA39', symbol: 'BEFA39.SA' },
  { name: 'BEFG39', symbol: 'BEFG39.SA' },
  { name: 'BEFV39', symbol: 'BEFV39.SA' },
  { name: 'BEGD39', symbol: 'BEGD39.SA' },
  { name: 'BEGE39', symbol: 'BEGE39.SA' },
  { name: 'BEGU39', symbol: 'BEGU39.SA' },
  { name: 'BEMV39', symbol: 'BEMV39.SA' },
  { name: 'BERK34', symbol: 'BERK34.SA' },
  { name: 'BEWA39', symbol: 'BEWA39.SA' },
  { name: 'BEWC39', symbol: 'BEWC39.SA' },
  { name: 'BEWG39', symbol: 'BEWG39.SA' },
  { name: 'BEWH39', symbol: 'BEWH39.SA' },
  { name: 'BEWJ39', symbol: 'BEWJ39.SA' },
  { name: 'BEWL39', symbol: 'BEWL39.SA' },
  { name: 'BEWQ39', symbol: 'BEWQ39.SA' },
  { name: 'BEWT39', symbol: 'BEWT39.SA' },
  { name: 'BEWU39', symbol: 'BEWU39.SA' },
  { name: 'BEWW39', symbol: 'BEWW39.SA' },
  { name: 'BEWY39', symbol: 'BEWY39.SA' },
  { name: 'BEWZ39', symbol: 'BEWZ39.SA' },
  { name: 'BEZU39', symbol: 'BEZU39.SA' },
  { name: 'BFAV39', symbol: 'BFAV39.SA' },
  { name: 'BFXI39', symbol: 'BFXI39.SA' },
  { name: 'BGIP3', symbol: 'BGIP3.SA' },
  { name: 'BGIP4', symbol: 'BGIP4.SA' },
  { name: 'BGRT39', symbol: 'BGRT39.SA' },
  { name: 'BGWH39', symbol: 'BGWH39.SA' },
  { name: 'BHEF39', symbol: 'BHEF39.SA' },
  { name: 'BHPG34', symbol: 'BHPG34.SA' },
  { name: 'BIAU39', symbol: 'BIAU39.SA' },
  { name: 'BIBB39', symbol: 'BIBB39.SA' },
  { name: 'BICR11', symbol: 'BICR11.SA' },
  { name: 'BIDI11', symbol: 'BIDI11.SA' },
  { name: 'BIDI3', symbol: 'BIDI3.SA' },
  { name: 'BIDI4', symbol: 'BIDI4.SA' },
  { name: 'BIEF39', symbol: 'BIEF39.SA' },
  { name: 'BIEM39', symbol: 'BIEM39.SA' },
  { name: 'BIEU39', symbol: 'BIEU39.SA' },
  { name: 'BIEV39', symbol: 'BIEV39.SA' },
  { name: 'BIGF39', symbol: 'BIGF39.SA' },
  { name: 'BIHI39', symbol: 'BIHI39.SA' },
  { name: 'BIIB34', symbol: 'BIIB34.SA' },
  { name: 'BIJH39', symbol: 'BIJH39.SA' },
  { name: 'BIJR39', symbol: 'BIJR39.SA' },
  { name: 'BILF39', symbol: 'BILF39.SA' },
  { name: 'BIOM3', symbol: 'BIOM3.SA' },
  { name: 'BITH11', symbol: 'BITH11.SA' },
  { name: 'BITO39', symbol: 'BITO39.SA' },
  { name: 'BIVB39', symbol: 'BIVB39.SA' },
  { name: 'BIVE39', symbol: 'BIVE39.SA' },
  { name: 'BIVW39', symbol: 'BIVW39.SA' },
  { name: 'BIWF39', symbol: 'BIWF39.SA' },
  { name: 'BIWM39', symbol: 'BIWM39.SA' },
  { name: 'BIXJ39', symbol: 'BIXJ39.SA' },
  { name: 'BIXN39', symbol: 'BIXN39.SA' },
  { name: 'BIYF39', symbol: 'BIYF39.SA' },
  { name: 'BIYG39', symbol: 'BIYG39.SA' },
  { name: 'BIYW39', symbol: 'BIYW39.SA' },
  { name: 'BKBR3', symbol: 'BKBR3.SA' },
  { name: 'BKNG34', symbol: 'BKNG34.SA' },
  { name: 'BLAK34', symbol: 'BLAK34.SA' },
  { name: 'BLAU3', symbol: 'BLAU3.SA' },
  { name: 'BLCP11', symbol: 'BLCP11.SA' },
  { name: 'BLMC11', symbol: 'BLMC11.SA' },
  { name: 'BLMG11', symbol: 'BLMG11.SA' },
  { name: 'BLMR11', symbol: 'BLMR11.SA' },
  { name: 'BMEB3', symbol: 'BMEB3.SA' },
  { name: 'BMEB4', symbol: 'BMEB4.SA' },
  { name: 'BMGB4', symbol: 'BMGB4.SA' },
  { name: 'BMIN3', symbol: 'BMIN3.SA' },
  { name: 'BMIN4', symbol: 'BMIN4.SA' },
  { name: 'BMKS3', symbol: 'BMKS3.SA' },
  { name: 'BMLC11', symbol: 'BMLC11.SA' },
  { name: 'BMOB3', symbol: 'BMOB3.SA' },
  { name: 'BMTU39', symbol: 'BMTU39.SA' },
  { name: 'BMYB34', symbol: 'BMYB34.SA' },
  { name: 'BNBR3', symbol: 'BNBR3.SA' },
  { name: 'BNDA39', symbol: 'BNDA39.SA' },
  { name: 'BNFS11', symbol: 'BNFS11.SA' },
  { name: 'BOAC34', symbol: 'BOAC34.SA' },
  { name: 'BOAS3', symbol: 'BOAS3.SA' },
  { name: 'BOBR4', symbol: 'BOBR4.SA' },
  { name: 'BOEI34', symbol: 'BOEI34.SA' },
  { name: 'BONY34', symbol: 'BONY34.SA' },
  { name: 'BOVA11', symbol: 'BOVA11.SA' },
  { name: 'BOVB11', symbol: 'BOVB11.SA' },
  { name: 'BOVV11', symbol: 'BOVV11.SA' },
  { name: 'BOVX11', symbol: 'BOVX11.SA' },
  { name: 'BPAC11', symbol: 'BPAC11.SA' },
  { name: 'BPAC3', symbol: 'BPAC3.SA' },
  { name: 'BPAC5', symbol: 'BPAC5.SA' },
  { name: 'BPAN4', symbol: 'BPAN4.SA' },
  { name: 'BPFF11', symbol: 'BPFF11.SA' },
  { name: 'BPML11', symbol: 'BPML11.SA' },
  { name: 'BPRP11', symbol: 'BPRP11.SA' },
  { name: 'BQUA39', symbol: 'BQUA39.SA' },
  { name: 'BRAP3', symbol: 'BRAP3.SA' },
  { name: 'BRAP4', symbol: 'BRAP4.SA' },
  { name: 'BRAX11', symbol: 'BRAX11.SA' },
  { name: 'BRBI11', symbol: 'BRBI11.SA' },
  { name: 'BRCO11', symbol: 'BRCO11.SA' },
  { name: 'BRCR11', symbol: 'BRCR11.SA' },
  { name: 'BREV11', symbol: 'BREV11.SA' },
  { name: 'BRFS3', symbol: 'BRFS3.SA' },
  { name: 'BRGE11', symbol: 'BRGE11.SA' },
  { name: 'BRGE12', symbol: 'BRGE12.SA' },
  { name: 'BRGE3', symbol: 'BRGE3.SA' },
  { name: 'BRGE5', symbol: 'BRGE5.SA' },
  { name: 'BRGE8', symbol: 'BRGE8.SA' },
  { name: 'BRIT3', symbol: 'BRIT3.SA' },
  { name: 'BRIV3', symbol: 'BRIV3.SA' },
  { name: 'BRIV4', symbol: 'BRIV4.SA' },
  { name: 'BRKM3', symbol: 'BRKM3.SA' },
  { name: 'BRKM5', symbol: 'BRKM5.SA' },
  { name: 'BRKM6', symbol: 'BRKM6.SA' },
  { name: 'BRML3', symbol: 'BRML3.SA' },
  { name: 'BRPR3', symbol: 'BRPR3.SA' },
  { name: 'BRSR3', symbol: 'BRSR3.SA' },
  { name: 'BRSR5', symbol: 'BRSR5.SA' },
  { name: 'BRSR6', symbol: 'BRSR6.SA' },
  { name: 'BSIZ39', symbol: 'BSIZ39.SA' },
  { name: 'BSLV39', symbol: 'BSLV39.SA' },
  { name: 'BSUS39', symbol: 'BSUS39.SA' },
  { name: 'BTAL11', symbol: 'BTAL11.SA' },
  { name: 'BTCR11', symbol: 'BTCR11.SA' },
  { name: 'BTLG11', symbol: 'BTLG11.SA' },
  { name: 'BTRA11', symbol: 'BTRA11.SA' },
  { name: 'BUSM39', symbol: 'BUSM39.SA' },
  { name: 'BUSR39', symbol: 'BUSR39.SA' },
  { name: 'BVLU39', symbol: 'BVLU39.SA' },
  { name: 'BXTC39', symbol: 'BXTC39.SA' },
  { name: 'BZLI11', symbol: 'BZLI11.SA' },
  { name: 'CAMB3', symbol: 'CAMB3.SA' },
  { name: 'CAML3', symbol: 'CAML3.SA' },
  { name: 'CAON34', symbol: 'CAON34.SA' },
  { name: 'CARD3', symbol: 'CARD3.SA' },
  { name: 'CARE11', symbol: 'CARE11.SA' },
  { name: 'CASH3', symbol: 'CASH3.SA' },
  { name: 'CBAV3', symbol: 'CBAV3.SA' },
  { name: 'CBOP11', symbol: 'CBOP11.SA' },
  { name: 'CCRF11', symbol: 'CCRF11.SA' },
  { name: 'CCRO3', symbol: 'CCRO3.SA' },
  { name: 'CEAB3', symbol: 'CEAB3.SA' },
  { name: 'CEBR3', symbol: 'CEBR3.SA' },
  { name: 'CEBR5', symbol: 'CEBR5.SA' },
  { name: 'CEBR6', symbol: 'CEBR6.SA' },
  { name: 'CEDO4', symbol: 'CEDO4.SA' },
  { name: 'CEEB3', symbol: 'CEEB3.SA' },
  { name: 'CEEB5', symbol: 'CEEB5.SA' },
  { name: 'CEED4', symbol: 'CEED4.SA' },
  { name: 'CEOC11', symbol: 'CEOC11.SA' },
  { name: 'CEPE5', symbol: 'CEPE5.SA' },
  { name: 'CEPE6', symbol: 'CEPE6.SA' },
  { name: 'CGAS3', symbol: 'CGAS3.SA' },
  { name: 'CGAS5', symbol: 'CGAS5.SA' },
  { name: 'CGRA3', symbol: 'CGRA3.SA' },
  { name: 'CGRA4', symbol: 'CGRA4.SA' },
  { name: 'CHCM34', symbol: 'CHCM34.SA' },
  { name: 'CHME34', symbol: 'CHME34.SA' },
  { name: 'CHVX34', symbol: 'CHVX34.SA' },
  { name: 'CIEL3', symbol: 'CIEL3.SA' },
  { name: 'CJCT11', symbol: 'CJCT11.SA' },
  { name: 'CLSA3', symbol: 'CLSA3.SA' },
  { name: 'CLSC4', symbol: 'CLSC4.SA' },
  { name: 'CMCS34', symbol: 'CMCS34.SA' },
  { name: 'CMIG3', symbol: 'CMIG3.SA' },
  { name: 'CMIG4', symbol: 'CMIG4.SA' },
  { name: 'CMIN3', symbol: 'CMIN3.SA' },
  { name: 'CNES11', symbol: 'CNES11.SA' },
  { name: 'CNIC34', symbol: 'CNIC34.SA' },
  { name: 'COCA34', symbol: 'COCA34.SA' },
  { name: 'COCE3', symbol: 'COCE3.SA' },
  { name: 'COCE5', symbol: 'COCE5.SA' },
  { name: 'COGN3', symbol: 'COGN3.SA' },
  { name: 'COPH34', symbol: 'COPH34.SA' },
  { name: 'CORM11', symbol: 'CORM11.SA' },
  { name: 'COWC34', symbol: 'COWC34.SA' },
  { name: 'CPFE3', symbol: 'CPFE3.SA' },
  { name: 'CPFF11', symbol: 'CPFF11.SA' },
  { name: 'CPLE11', symbol: 'CPLE11.SA' },
  { name: 'CPLE3', symbol: 'CPLE3.SA' },
  { name: 'CPLE6', symbol: 'CPLE6.SA' },
  { name: 'CPTI11', symbol: 'CPTI11.SA' },
  { name: 'CPTS11', symbol: 'CPTS11.SA' },
  { name: 'CPTS11B', symbol: 'CPTS11B.SA' },
  { name: 'CRDE3', symbol: 'CRDE3.SA' },
  { name: 'CRFB3', symbol: 'CRFB3.SA' },
  { name: 'CRFF11', symbol: 'CRFF11.SA' },
  { name: 'CRIV3', symbol: 'CRIV3.SA' },
  { name: 'CRIV4', symbol: 'CRIV4.SA' },
  { name: 'CRPG5', symbol: 'CRPG5.SA' },
  { name: 'CRPG6', symbol: 'CRPG6.SA' },
  { name: 'CSAN3', symbol: 'CSAN3.SA' },
  { name: 'CSED3', symbol: 'CSED3.SA' },
  { name: 'CSMG3', symbol: 'CSMG3.SA' },
  { name: 'CSNA3', symbol: 'CSNA3.SA' },
  { name: 'CSRN3', symbol: 'CSRN3.SA' },
  { name: 'CSRN5', symbol: 'CSRN5.SA' },
  { name: 'CSRN6', symbol: 'CSRN6.SA' },
  { name: 'CTGP34', symbol: 'CTGP34.SA' },
  { name: 'CTKA3', symbol: 'CTKA3.SA' },
  { name: 'CTKA4', symbol: 'CTKA4.SA' },
  { name: 'CTNM3', symbol: 'CTNM3.SA' },
  { name: 'CTNM4', symbol: 'CTNM4.SA' },
  { name: 'CTSA3', symbol: 'CTSA3.SA' },
  { name: 'CTSA4', symbol: 'CTSA4.SA' },
  { name: 'CTXT11', symbol: 'CTXT11.SA' },
  { name: 'CURY3', symbol: 'CURY3.SA' },
  { name: 'CVBI11', symbol: 'CVBI11.SA' },
  { name: 'CVCB3', symbol: 'CVCB3.SA' },
  { name: 'CVSH34', symbol: 'CVSH34.SA' },
  { name: 'CXCE11B', symbol: 'CXCE11B.SA' },
  { name: 'CXCO11', symbol: 'CXCO11.SA' },
  { name: 'CXRI11', symbol: 'CXRI11.SA' },
  { name: 'CXSE3', symbol: 'CXSE3.SA' },
  { name: 'CXTL11', symbol: 'CXTL11.SA' },
  { name: 'CYRE3', symbol: 'CYRE3.SA' },
  { name: 'D1VN34', symbol: 'D1VN34.SA' },
  { name: 'DASA3', symbol: 'DASA3.SA' },
  { name: 'DCRA11', symbol: 'DCRA11.SA' },
  { name: 'DDNB34', symbol: 'DDNB34.SA' },
  { name: 'DESK3', symbol: 'DESK3.SA' },
  { name: 'DEVA11', symbol: 'DEVA11.SA' },
  { name: 'DEXP3', symbol: 'DEXP3.SA' },
  { name: 'DGCO34', symbol: 'DGCO34.SA' },
  { name: 'DHER34', symbol: 'DHER34.SA' },
  { name: 'DIRR3', symbol: 'DIRR3.SA' },
  { name: 'DISB34', symbol: 'DISB34.SA' },
  { name: 'DIVO', symbol: 'DIVO' },
  { name: 'DIVO11', symbol: 'DIVO11.SA' },
  { name: 'DMMO11', symbol: 'DMMO11.SA' },
  { name: 'DMMO3', symbol: 'DMMO3.SA' },
  { name: 'DMVF3', symbol: 'DMVF3.SA' },
  { name: 'DOHL4', symbol: 'DOHL4.SA' },
  { name: 'DOTZ3', symbol: 'DOTZ3.SA' },
  { name: 'DRIT11B', symbol: 'DRIT11B.SA' },
  { name: 'DTCY3', symbol: 'DTCY3.SA' },
  { name: 'DUKB34', symbol: 'DUKB34.SA' },
  { name: 'DVFF11', symbol: 'DVFF11.SA' },
  { name: 'DXCO3', symbol: 'DXCO3.SA' },
  { name: 'E1QN34', symbol: 'E1QN34.SA' },
  { name: 'E1TN34', symbol: 'E1TN34.SA' },
  { name: 'EALT3', symbol: 'EALT3.SA' },
  { name: 'EALT4', symbol: 'EALT4.SA' },
  { name: 'ECOO11', symbol: 'ECOO11.SA' },
  { name: 'ECOR3', symbol: 'ECOR3.SA' },
  { name: 'EDFO11B', symbol: 'EDFO11B.SA' },
  { name: 'EDGA11', symbol: 'EDGA11.SA' },
  { name: 'EGIE3', symbol: 'EGIE3.SA' },
  { name: 'EGYR11', symbol: 'EGYR11.SA' },
  { name: 'EKTR4', symbol: 'EKTR4.SA' },
  { name: 'ELET3', symbol: 'ELET3.SA' },
  { name: 'ELET5', symbol: 'ELET5.SA' },
  { name: 'ELET6', symbol: 'ELET6.SA' },
  { name: 'ELMD3', symbol: 'ELMD3.SA' },
  { name: 'EMAE4', symbol: 'EMAE4.SA' },
  { name: 'EMBR3', symbol: 'EMBR3.SA' },
  { name: 'ENAT3', symbol: 'ENAT3.SA' },
  { name: 'ENBR3', symbol: 'ENBR3.SA' },
  { name: 'ENEV3', symbol: 'ENEV3.SA' },
  { name: 'ENGI11', symbol: 'ENGI11.SA' },
  { name: 'ENGI3', symbol: 'ENGI3.SA' },
  { name: 'ENGI4', symbol: 'ENGI4.SA' },
  { name: 'ENJU3', symbol: 'ENJU3.SA' },
  { name: 'ENMT3', symbol: 'ENMT3.SA' },
  { name: 'ENMT4', symbol: 'ENMT4.SA' },
  { name: 'EQPA3', symbol: 'EQPA3.SA' },
  { name: 'EQPA5', symbol: 'EQPA5.SA' },
  { name: 'EQPA7', symbol: 'EQPA7.SA' },
  { name: 'EQTL3', symbol: 'EQTL3.SA' },
  { name: 'ESGB', symbol: 'ESGB' },
  { name: 'ESGB11', symbol: 'ESGB11.SA' },
  { name: 'ESPA3', symbol: 'ESPA3.SA' },
  { name: 'ESTR4', symbol: 'ESTR4.SA' },
  { name: 'ETER3', symbol: 'ETER3.SA' },
  { name: 'ETHE11', symbol: 'ETHE11.SA' },
  { name: 'EUCA3', symbol: 'EUCA3.SA' },
  { name: 'EUCA4', symbol: 'EUCA4.SA' },
  { name: 'EURO11', symbol: 'EURO11.SA' },
  { name: 'EURP11', symbol: 'EURP11.SA' },
  { name: 'EVBI11', symbol: 'EVBI11.SA' },
  { name: 'EVEN3', symbol: 'EVEN3.SA' },
  { name: 'EXXO34', symbol: 'EXXO34.SA' },
  { name: 'EZTC3', symbol: 'EZTC3.SA' },
  { name: 'F1NI34', symbol: 'F1NI34.SA' },
  { name: 'FAED11', symbol: 'FAED11.SA' },
  { name: 'FAMB11B', symbol: 'FAMB11B.SA' },
  { name: 'FATN11', symbol: 'FATN11.SA' },
  { name: 'FBOK34', symbol: 'FBOK34.SA' },
  { name: 'FCFL11', symbol: 'FCFL11.SA' },
  { name: 'FDMO34', symbol: 'FDMO34.SA' },
  { name: 'FESA3', symbol: 'FESA3.SA' },
  { name: 'FESA4', symbol: 'FESA4.SA' },
  { name: 'FEXC11', symbol: 'FEXC11.SA' },
  { name: 'FHER3', symbol: 'FHER3.SA' },
  { name: 'FIGS11', symbol: 'FIGS11.SA' },
  { name: 'FIIB11', symbol: 'FIIB11.SA' },
  { name: 'FIIP11B', symbol: 'FIIP11B.SA' },
  { name: 'FIND', symbol: 'FIND' },
  { name: 'FIND11', symbol: 'FIND11.SA' },
  { name: 'FIQE3', symbol: 'FIQE3.SA' },
  { name: 'FLCR11', symbol: 'FLCR11.SA' },
  { name: 'FLMA11', symbol: 'FLMA11.SA' },
  { name: 'FLRP11', symbol: 'FLRP11.SA' },
  { name: 'FLRY3', symbol: 'FLRY3.SA' },
  { name: 'FMOF11', symbol: 'FMOF11.SA' },
  { name: 'FNAM11', symbol: 'FNAM11.SA' },
  { name: 'FNOR11', symbol: 'FNOR11.SA' },
  { name: 'FPAB11', symbol: 'FPAB11.SA' },
  { name: 'FPOR11', symbol: 'FPOR11.SA' },
  { name: 'FRAS3', symbol: 'FRAS3.SA' },
  { name: 'FRIO3', symbol: 'FRIO3.SA' },
  { name: 'FRTA3', symbol: 'FRTA3.SA' },
  { name: 'FSPE11', symbol: 'FSPE11.SA' },
  { name: 'FSRF11', symbol: 'FSRF11.SA' },
  { name: 'FSTU11', symbol: 'FSTU11.SA' },
  { name: 'FVPQ11', symbol: 'FVPQ11.SA' },
  { name: 'G2DI33', symbol: 'G2DI33.SA' },
  { name: 'GALG11', symbol: 'GALG11.SA' },
  { name: 'GCFF11', symbol: 'GCFF11.SA' },
  { name: 'GCRI11', symbol: 'GCRI11.SA' },
  { name: 'GDBR34', symbol: 'GDBR34.SA' },
  { name: 'GENB11', symbol: 'GENB11.SA' },
  { name: 'GEOO34', symbol: 'GEOO34.SA' },
  { name: 'GEPA3', symbol: 'GEPA3.SA' },
  { name: 'GEPA4', symbol: 'GEPA4.SA' },
  { name: 'GETT11', symbol: 'GETT11.SA' },
  { name: 'GFSA3', symbol: 'GFSA3.SA' },
  { name: 'GGBR3', symbol: 'GGBR3.SA' },
  { name: 'GGBR4', symbol: 'GGBR4.SA' },
  { name: 'GGPS3', symbol: 'GGPS3.SA' },
  { name: 'GGRC11', symbol: 'GGRC11.SA' },
  { name: 'GILD34', symbol: 'GILD34.SA' },
  { name: 'GMAT3', symbol: 'GMAT3.SA' },
  { name: 'GMCO34', symbol: 'GMCO34.SA' },
  { name: 'GOAU3', symbol: 'GOAU3.SA' },
  { name: 'GOAU4', symbol: 'GOAU4.SA' },
  { name: 'GOGL34', symbol: 'GOGL34.SA' },
  { name: 'GOGL35', symbol: 'GOGL35.SA' },
  { name: 'GOLD11', symbol: 'GOLD11.SA' },
  { name: 'GOLL4', symbol: 'GOLL4.SA' },
  { name: 'GOVE11', symbol: 'GOVE11.SA' },
  { name: 'GPIV33', symbol: 'GPIV33.SA' },
  { name: 'GRND3', symbol: 'GRND3.SA' },
  { name: 'GSFI11', symbol: 'GSFI11.SA' },
  { name: 'GSGI34', symbol: 'GSGI34.SA' },
  { name: 'GSHP3', symbol: 'GSHP3.SA' },
  { name: 'GTWR11', symbol: 'GTWR11.SA' },
  { name: 'GUAR3', symbol: 'GUAR3.SA' },
  { name: 'GURU', symbol: 'GURU' },
  { name: 'HAAA11', symbol: 'HAAA11.SA' },
  { name: 'HABT11', symbol: 'HABT11.SA' },
  { name: 'HAGA3', symbol: 'HAGA3.SA' },
  { name: 'HAGA4', symbol: 'HAGA4.SA' },
  { name: 'HAPV3', symbol: 'HAPV3.SA' },
  { name: 'HASH11', symbol: 'HASH11.SA' },
  { name: 'HBCR11', symbol: 'HBCR11.SA' },
  { name: 'HBOR3', symbol: 'HBOR3.SA' },
  { name: 'HBRE3', symbol: 'HBRE3.SA' },
  { name: 'HBRH11', symbol: 'HBRH11.SA' },
  { name: 'HBSA3', symbol: 'HBSA3.SA' },
  { name: 'HBTS5', symbol: 'HBTS5.SA' },
  { name: 'HCHG11', symbol: 'HCHG11.SA' },
  { name: 'HCRI11', symbol: 'HCRI11.SA' },
  { name: 'HCST11', symbol: 'HCST11.SA' },
  { name: 'HCTR11', symbol: 'HCTR11.SA' },
  { name: 'HETA4', symbol: 'HETA4.SA' },
  { name: 'HFOF11', symbol: 'HFOF11.SA' },
  { name: 'HGBS11', symbol: 'HGBS11.SA' },
  { name: 'HGCR11', symbol: 'HGCR11.SA' },
  { name: 'HGFF11', symbol: 'HGFF11.SA' },
  { name: 'HGIC11', symbol: 'HGIC11.SA' },
  { name: 'HGLG11', symbol: 'HGLG11.SA' },
  { name: 'HGPO11', symbol: 'HGPO11.SA' },
  { name: 'HGRE11', symbol: 'HGRE11.SA' },
  { name: 'HGRU11', symbol: 'HGRU11.SA' },
  { name: 'HLOG11', symbol: 'HLOG11.SA' },
  { name: 'HOME34', symbol: 'HOME34.SA' },
  { name: 'HONB34', symbol: 'HONB34.SA' },
  { name: 'HOOT4', symbol: 'HOOT4.SA' },
  { name: 'HOSI11', symbol: 'HOSI11.SA' },
  { name: 'HPDP11', symbol: 'HPDP11.SA' },
  { name: 'HRDF11', symbol: 'HRDF11.SA' },
  { name: 'HREC11', symbol: 'HREC11.SA' },
  { name: 'HSAF11', symbol: 'HSAF11.SA' },
  { name: 'HSLG11', symbol: 'HSLG11.SA' },
  { name: 'HSML11', symbol: 'HSML11.SA' },
  { name: 'HSRE11', symbol: 'HSRE11.SA' },
  { name: 'HTMX11', symbol: 'HTMX11.SA' },
  { name: 'HUSC11', symbol: 'HUSC11.SA' },
  { name: 'HYPE3', symbol: 'HYPE3.SA' },
  { name: 'IBCR11', symbol: 'IBCR11.SA' },
  { name: 'IBFF11', symbol: 'IBFF11.SA' },
  { name: 'IBOV11', symbol: 'IBOV11.SA' },
  { name: 'IBRA', symbol: 'IBRA.SA' },
  { name: 'IBXX', symbol: 'IBXX.SA' },
  { name: 'ICO2', symbol: 'ICO2.SA' },
  { name: 'ICON', symbol: 'ICON' },
  { name: 'IDIV', symbol: 'IDIV' },
  { name: 'IFCM3', symbol: 'IFCM3.SA' },
  { name: 'IFIX', symbol: 'IFIX' },
  { name: 'IFNC', symbol: 'IFNC.SA' },
  { name: 'IGBR3', symbol: 'IGBR3.SA' },
  { name: 'IGTI11', symbol: 'IGTI11.SA' },
  { name: 'IGTI3', symbol: 'IGTI3.SA' },
  { name: 'IMOB', symbol: 'IMOB.SA' },
  { name: 'INDX', symbol: 'INDX.SA' },
  { name: 'INEP3', symbol: 'INEP3.SA' },
  { name: 'INEP4', symbol: 'INEP4.SA' },
  { name: 'INGP', symbol: 'INGP' },
  { name: 'INTB3', symbol: 'INTB3.SA' },
  { name: 'IRBR3', symbol: 'IRBR3.SA' },
  { name: 'IRDM11', symbol: 'IRDM11.SA' },
  { name: 'ISEE', symbol: 'ISEE.SA' },
  { name: 'ISUS11', symbol: 'ISUS11.SA' },
  { name: 'ITAG', symbol: 'ITAG.SA' },
  { name: 'ITLC34', symbol: 'ITLC34.SA' },
  { name: 'ITSA3', symbol: 'ITSA3.SA' },
  { name: 'ITSA4', symbol: 'ITSA4.SA' },
  { name: 'ITUB3', symbol: 'ITUB3.SA' },
  { name: 'ITUB4', symbol: 'ITUB4.SA' },
  { name: 'IVVB11', symbol: 'IVVB11.SA' },
  { name: 'JALL3', symbol: 'JALL3.SA' },
  { name: 'JBSS3', symbol: 'JBSS3.SA' },
  { name: 'JBSS3F', symbol: 'JBSS3F.SA' },
  { name: 'JDCO34', symbol: 'JDCO34.SA' },
  { name: 'JFLL11', symbol: 'JFLL11.SA' },
  { name: 'JHSF3', symbol: 'JHSF3.SA' },
  { name: 'JNJB34', symbol: 'JNJB34.SA' },
  { name: 'JOPA3', symbol: 'JOPA3.SA' },
  { name: 'JPMC34', symbol: 'JPMC34.SA' },
  { name: 'JPPA11', symbol: 'JPPA11.SA' },
  { name: 'JRDM11', symbol: 'JRDM11.SA' },
  { name: 'JSLG3', symbol: 'JSLG3.SA' },
  { name: 'JSRE11', symbol: 'JSRE11.SA' },
  { name: 'KDIF11', symbol: 'KDIF11.SA' },
  { name: 'KEPL3', symbol: 'KEPL3.SA' },
  { name: 'KFOF11', symbol: 'KFOF11.SA' },
  { name: 'KHCB34', symbol: 'KHCB34.SA' },
  { name: 'KINP11', symbol: 'KINP11.SA' },
  { name: 'KISU11', symbol: 'KISU11.SA' },
  { name: 'KLBN11', symbol: 'KLBN11.SA' },
  { name: 'KLBN3', symbol: 'KLBN3.SA' },
  { name: 'KLBN4', symbol: 'KLBN4.SA' },
  { name: 'KNCR11', symbol: 'KNCR11.SA' },
  { name: 'KNHY11', symbol: 'KNHY11.SA' },
  { name: 'KNIP11', symbol: 'KNIP11.SA' },
  { name: 'KNRE11', symbol: 'KNRE11.SA' },
  { name: 'KNRI11', symbol: 'KNRI11.SA' },
  { name: 'KNSC11', symbol: 'KNSC11.SA' },
  { name: 'KRSA3', symbol: 'KRSA3.SA' },
  { name: 'LAND3', symbol: 'LAND3.SA' },
  { name: 'LASC11', symbol: 'LASC11.SA' },
  { name: 'LAVV3', symbol: 'LAVV3.SA' },
  { name: 'LCAM3', symbol: 'LCAM3.SA' },
  { name: 'LEVE3', symbol: 'LEVE3.SA' },
  { name: 'LFTT11', symbol: 'LFTT11.SA' },
  { name: 'LGCP11', symbol: 'LGCP11.SA' },
  { name: 'LIGT3', symbol: 'LIGT3.SA' },
  { name: 'LILY34', symbol: 'LILY34.SA' },
  { name: 'LJQQ3', symbol: 'LJQQ3.SA' },
  { name: 'LLIS3', symbol: 'LLIS3.SA' },
  { name: 'LMTB34', symbol: 'LMTB34.SA' },
  { name: 'LOGG3', symbol: 'LOGG3.SA' },
  { name: 'LOGN3', symbol: 'LOGN3.SA' },
  { name: 'LOWC34', symbol: 'LOWC34.SA' },
  { name: 'LPSB3', symbol: 'LPSB3.SA' },
  { name: 'LREN3', symbol: 'LREN3.SA' },
  { name: 'LUGG11', symbol: 'LUGG11.SA' },
  { name: 'LUPA3', symbol: 'LUPA3.SA' },
  { name: 'LUXM4', symbol: 'LUXM4.SA' },
  { name: 'LVBI11', symbol: 'LVBI11.SA' },
  { name: 'LVTC3', symbol: 'LVTC3.SA' },
  { name: 'LWSA3', symbol: 'LWSA3.SA' },
  { name: 'M1RN34', symbol: 'M1RN34.SA' },
  { name: 'MACY34', symbol: 'MACY34.SA' },
  { name: 'MALL11', symbol: 'MALL11.SA' },
  { name: 'MATB11', symbol: 'MATB11.SA' },
  { name: 'MATD3', symbol: 'MATD3.SA' },
  { name: 'MAXR11', symbol: 'MAXR11.SA' },
  { name: 'MBLY3', symbol: 'MBLY3.SA' },
  { name: 'MBRF11', symbol: 'MBRF11.SA' },
  { name: 'MCCI11', symbol: 'MCCI11.SA' },
  { name: 'MCDC34', symbol: 'MCDC34.SA' },
  { name: 'MCHF11', symbol: 'MCHF11.SA' },
  { name: 'MCHY11', symbol: 'MCHY11.SA' },
  { name: 'MDIA3', symbol: 'MDIA3.SA' },
  { name: 'MDLZ34', symbol: 'MDLZ34.SA' },
  { name: 'MDNE3', symbol: 'MDNE3.SA' },
  { name: 'MEAL3', symbol: 'MEAL3.SA' },
  { name: 'MEGA3', symbol: 'MEGA3.SA' },
  { name: 'MELI34', symbol: 'MELI34.SA' },
  { name: 'MELK3', symbol: 'MELK3.SA' },
  { name: 'MERC4', symbol: 'MERC4.SA' },
  { name: 'METB34', symbol: 'METB34.SA' },
  { name: 'MFAI11', symbol: 'MFAI11.SA' },
  { name: 'MFII11', symbol: 'MFII11.SA' },
  { name: 'MGCR11', symbol: 'MGCR11.SA' },
  { name: 'MGEL4', symbol: 'MGEL4.SA' },
  { name: 'MGFF11', symbol: 'MGFF11.SA' },
  { name: 'MGHT11', symbol: 'MGHT11.SA' },
  { name: 'MGLG11', symbol: 'MGLG11.SA' },
  { name: 'MGLU3', symbol: 'MGLU3.SA' },
  { name: 'MILS3', symbol: 'MILS3.SA' },
  { name: 'MINT11', symbol: 'MINT11.SA' },
  { name: 'MLAS3', symbol: 'MLAS3.SA' },
  { name: 'MLCX', symbol: 'MLCX.SA' },
  { name: 'MMMC34', symbol: 'MMMC34.SA' },
  { name: 'MNDL3', symbol: 'MNDL3.SA' },
  { name: 'MNPR3', symbol: 'MNPR3.SA' },
  { name: 'MOAR3', symbol: 'MOAR3.SA' },
  { name: 'MODL11', symbol: 'MODL11.SA' },
  { name: 'MOOO34', symbol: 'MOOO34.SA' },
  { name: 'MORE11', symbol: 'MORE11.SA' },
  { name: 'MOSI3', symbol: 'MOSI3.SA' },
  { name: 'MOVI3', symbol: 'MOVI3.SA' },
  { name: 'MRCK34', symbol: 'MRCK34.SA' },
  { name: 'MRFG3', symbol: 'MRFG3.SA' },
  { name: 'MRVE3', symbol: 'MRVE3.SA' },
  { name: 'MSBR34', symbol: 'MSBR34.SA' },
  { name: 'MSCD34', symbol: 'MSCD34.SA' },
  { name: 'MSFT34', symbol: 'MSFT34.SA' },
  { name: 'MSPA3', symbol: 'MSPA3.SA' },
  { name: 'MTIG4', symbol: 'MTIG4.SA' },
  { name: 'MTRE3', symbol: 'MTRE3.SA' },
  { name: 'MTSA4', symbol: 'MTSA4.SA' },
  { name: 'MULT3', symbol: 'MULT3.SA' },
  { name: 'MUTC34', symbol: 'MUTC34.SA' },
  { name: 'MWET4', symbol: 'MWET4.SA' },
  { name: 'MXRF11', symbol: 'MXRF11.SA' },
  { name: 'MYPK3', symbol: 'MYPK3.SA' },
  { name: 'NASD11', symbol: 'NASD11.SA' },
  { name: 'NAVT11', symbol: 'NAVT11.SA' },
  { name: 'NEOE3', symbol: 'NEOE3.SA' },
  { name: 'NEWL11', symbol: 'NEWL11.SA' },
  { name: 'NEWU11', symbol: 'NEWU11.SA' },
  { name: 'NFLX34', symbol: 'NFLX34.SA' },
  { name: 'NGRD3', symbol: 'NGRD3.SA' },
  { name: 'NIKE34', symbol: 'NIKE34.SA' },
  { name: 'NINJ3', symbol: 'NINJ3.SA' },
  { name: 'NOCG34', symbol: 'NOCG34.SA' },
  { name: 'NORD3', symbol: 'NORD3.SA' },
  { name: 'NPAR11', symbol: 'NPAR11.SA' },
  { name: 'NSLU11', symbol: 'NSLU11.SA' },
  { name: 'NTCO3', symbol: 'NTCO3.SA' },
  { name: 'NUBR33', symbol: 'NUBR33.SA' },
  { name: 'NVDC34', symbol: 'NVDC34.SA' },
  { name: 'NVHO11', symbol: 'NVHO11.SA' },
  { name: 'ODPV3', symbol: 'ODPV3.SA' },
  { name: 'OFSA3', symbol: 'OFSA3.SA' },
  { name: 'OIBR3', symbol: 'OIBR3.SA' },
  { name: 'OIBR4', symbol: 'OIBR4.SA' },
  { name: 'ONCO3', symbol: 'ONCO3.SA' },
  { name: 'ONEF11', symbol: 'ONEF11.SA' },
  { name: 'OPCT3', symbol: 'OPCT3.SA' },
  { name: 'ORCL34', symbol: 'ORCL34.SA' },
  { name: 'ORVR3', symbol: 'ORVR3.SA' },
  { name: 'OSXB3', symbol: 'OSXB3.SA' },
  { name: 'OUFF11', symbol: 'OUFF11.SA' },
  { name: 'OUJP11', symbol: 'OUJP11.SA' },
  { name: 'OULG11', symbol: 'OULG11.SA' },
  { name: 'OULG11B', symbol: 'OULG11B.SA' },
  { name: 'OURE11', symbol: 'OURE11.SA' },
  { name: 'P1LD34', symbol: 'P1LD34.SA' },
  { name: 'PABY11', symbol: 'PABY11.SA' },
  { name: 'PARD3', symbol: 'PARD3.SA' },
  { name: 'PATC11', symbol: 'PATC11.SA' },
  { name: 'PATI3', symbol: 'PATI3.SA' },
  { name: 'PATI4', symbol: 'PATI4.SA' },
  { name: 'PATL11', symbol: 'PATL11.SA' },
  { name: 'PCAR', symbol: 'PCAR' },
  { name: 'PCAR3', symbol: 'PCAR3.SA' },
  { name: 'PDGR3', symbol: 'PDGR3.SA' },
  { name: 'PDTC3', symbol: 'PDTC3.SA' },
  { name: 'PEMA11', symbol: 'PEMA11.SA' },
  { name: 'PEPB34', symbol: 'PEPB34.SA' },
  { name: 'PETR3', symbol: 'PETR3.SA' },
  { name: 'PETR4', symbol: 'PETR4.SA' },
  { name: 'PETZ3', symbol: 'PETZ3.SA' },
  { name: 'PFIN11', symbol: 'PFIN11.SA' },
  { name: 'PFIZ34', symbol: 'PFIZ34.SA' },
  { name: 'PFRM3', symbol: 'PFRM3.SA' },
  { name: 'PGCO34', symbol: 'PGCO34.SA' },
  { name: 'PGMN3', symbol: 'PGMN3.SA' },
  { name: 'PHMO34', symbol: 'PHMO34.SA' },
  { name: 'PIBB11', symbol: 'PIBB11.SA' },
  { name: 'PINE4', symbol: 'PINE4.SA' },
  { name: 'PLAS3', symbol: 'PLAS3.SA' },
  { name: 'PLCR11', symbol: 'PLCR11.SA' },
  { name: 'PLOG11', symbol: 'PLOG11.SA' },
  { name: 'PLPL3', symbol: 'PLPL3.SA' },
  { name: 'PLRI11', symbol: 'PLRI11.SA' },
  { name: 'PMAM3', symbol: 'PMAM3.SA' },
  { name: 'PNVL3', symbol: 'PNVL3.SA' },
  { name: 'POMO3', symbol: 'POMO3.SA' },
  { name: 'POMO4', symbol: 'POMO4.SA' },
  { name: 'PORD11', symbol: 'PORD11.SA' },
  { name: 'PORT3', symbol: 'PORT3.SA' },
  { name: 'POSI3', symbol: 'POSI3.SA' },
  { name: 'PPLA11', symbol: 'PPLA11.SA' },
  { name: 'PQAG11', symbol: 'PQAG11.SA' },
  { name: 'PQDP11', symbol: 'PQDP11.SA' },
  { name: 'PRIO3', symbol: 'PRIO3.SA' },
  { name: 'PRNR3', symbol: 'PRNR3.SA' },
  { name: 'PRSN11B', symbol: 'PRSN11B.SA' },
  { name: 'PRSV11', symbol: 'PRSV11.SA' },
  { name: 'PSSA3', symbol: 'PSSA3.SA' },
  { name: 'PSVM11', symbol: 'PSVM11.SA' },
  { name: 'PTBL3', symbol: 'PTBL3.SA' },
  { name: 'PTNT3', symbol: 'PTNT3.SA' },
  { name: 'PTNT4', symbol: 'PTNT4.SA' },
  { name: 'PVBI11', symbol: 'PVBI11.SA' },
  { name: 'PYPL34', symbol: 'PYPL34.SA' },
  { name: 'QAGR11', symbol: 'QAGR11.SA' },
  { name: 'QAMI11', symbol: 'QAMI11.SA' },
  { name: 'QBTC11', symbol: 'QBTC11.SA' },
  { name: 'QETH11', symbol: 'QETH11.SA' },
  { name: 'QUAL3', symbol: 'QUAL3.SA' },
  { name: 'RADL3', symbol: 'RADL3.SA' },
  { name: 'RAIL3', symbol: 'RAIL3.SA' },
  { name: 'RAIZ4', symbol: 'RAIZ4.SA' },
  { name: 'RANI3', symbol: 'RANI3.SA' },
  { name: 'RAPT3', symbol: 'RAPT3.SA' },
  { name: 'RAPT4', symbol: 'RAPT4.SA' },
  { name: 'RBCB11', symbol: 'RBCB11.SA' },
  { name: 'RBCO11', symbol: 'RBCO11.SA' },
  { name: 'RBDS11', symbol: 'RBDS11.SA' },
  { name: 'RBED11', symbol: 'RBED11.SA' },
  { name: 'RBFF11', symbol: 'RBFF11.SA' },
  { name: 'RBGS11', symbol: 'RBGS11.SA' },
  { name: 'RBHY11', symbol: 'RBHY11.SA' },
  { name: 'RBIR11', symbol: 'RBIR11.SA' },
  { name: 'RBLG11', symbol: 'RBLG11.SA' },
  { name: 'RBRD11', symbol: 'RBRD11.SA' },
  { name: 'RBRF11', symbol: 'RBRF11.SA' },
  { name: 'RBRL11', symbol: 'RBRL11.SA' },
  { name: 'RBRP11', symbol: 'RBRP11.SA' },
  { name: 'RBRR11', symbol: 'RBRR11.SA' },
  { name: 'RBRS11', symbol: 'RBRS11.SA' },
  { name: 'RBRY11', symbol: 'RBRY11.SA' },
  { name: 'RBVA11', symbol: 'RBVA11.SA' },
  { name: 'RCFA11', symbol: 'RCFA11.SA' },
  { name: 'RCRB11', symbol: 'RCRB11.SA' },
  { name: 'RCSL3', symbol: 'RCSL3.SA' },
  { name: 'RCSL4', symbol: 'RCSL4.SA' },
  { name: 'RDNI3', symbol: 'RDNI3.SA' },
  { name: 'RDOR3', symbol: 'RDOR3.SA' },
  { name: 'RDPD11', symbol: 'RDPD11.SA' },
  { name: 'RECR11', symbol: 'RECR11.SA' },
  { name: 'RECT11', symbol: 'RECT11.SA' },
  { name: 'RECV3', symbol: 'RECV3.SA' },
  { name: 'RECX11', symbol: 'RECX11.SA' },
  { name: 'REDE3', symbol: 'REDE3.SA' },
  { name: 'RELG11', symbol: 'RELG11.SA' },
  { name: 'RENT3', symbol: 'RENT3.SA' },
  { name: 'RFOF11', symbol: 'RFOF11.SA' },
  { name: 'RIGG34', symbol: 'RIGG34.SA' },
  { name: 'RMAI11', symbol: 'RMAI11.SA' },
  { name: 'RNDP11', symbol: 'RNDP11.SA' },
  { name: 'RNEW11', symbol: 'RNEW11.SA' },
  { name: 'RNEW3', symbol: 'RNEW3.SA' },
  { name: 'RNEW4', symbol: 'RNEW4.SA' },
  { name: 'RNGO11', symbol: 'RNGO11.SA' },
  { name: 'ROMI3', symbol: 'ROMI3.SA' },
  { name: 'RPAD3', symbol: 'RPAD3.SA' },
  { name: 'RPAD5', symbol: 'RPAD5.SA' },
  { name: 'RPAD6', symbol: 'RPAD6.SA' },
  { name: 'RPMG3', symbol: 'RPMG3.SA' },
  { name: 'RRCI11', symbol: 'RRCI11.SA' },
  { name: 'RRRP3', symbol: 'RRRP3.SA' },
  { name: 'RSID3', symbol: 'RSID3.SA' },
  { name: 'RSPD11', symbol: 'RSPD11.SA' },
  { name: 'RSUL4', symbol: 'RSUL4.SA' },
  { name: 'RVBI11', symbol: 'RVBI11.SA' },
  { name: 'RZAG11', symbol: 'RZAG11.SA' },
  { name: 'RZAK11', symbol: 'RZAK11.SA' },
  { name: 'RZTR11', symbol: 'RZTR11.SA' },
  { name: 'SADI11', symbol: 'SADI11.SA' },
  { name: 'SAIC11B', symbol: 'SAIC11B.SA' },
  { name: 'SANB', symbol: 'SANB' },
  { name: 'SANB11', symbol: 'SANB11.SA' },
  { name: 'SANB3', symbol: 'SANB3.SA' },
  { name: 'SANB4', symbol: 'SANB4.SA' },
  { name: 'SAPP34', symbol: 'SAPP34.SA' },
  { name: 'SAPR11', symbol: 'SAPR11.SA' },
  { name: 'SAPR3', symbol: 'SAPR3.SA' },
  { name: 'SAPR4', symbol: 'SAPR4.SA' },
  { name: 'SARE11', symbol: 'SARE11.SA' },
  { name: 'SBFG3', symbol: 'SBFG3.SA' },
  { name: 'SBSP3', symbol: 'SBSP3.SA' },
  { name: 'SBUB34', symbol: 'SBUB34.SA' },
  { name: 'SCAR3', symbol: 'SCAR3.SA' },
  { name: 'SCHW34', symbol: 'SCHW34.SA' },
  { name: 'SCPF11', symbol: 'SCPF11.SA' },
  { name: 'SDIL11', symbol: 'SDIL11.SA' },
  { name: 'SEER3', symbol: 'SEER3.SA' },
  { name: 'SEQL3', symbol: 'SEQL3.SA' },
  { name: 'SEQR11', symbol: 'SEQR11.SA' },
  { name: 'SGPS3', symbol: 'SGPS3.SA' },
  { name: 'SHOT11', symbol: 'SHOT11.SA' },
  { name: 'SHOW3', symbol: 'SHOW3.SA' },
  { name: 'SHPH11', symbol: 'SHPH11.SA' },
  { name: 'SHUL4', symbol: 'SHUL4.SA' },
  { name: 'SIMH3', symbol: 'SIMH3.SA' },
  { name: 'SLBG34', symbol: 'SLBG34.SA' },
  { name: 'SLCE3', symbol: 'SLCE3.SA' },
  { name: 'SLED3', symbol: 'SLED3.SA' },
  { name: 'SLED4', symbol: 'SLED4.SA' },
  { name: 'SMAC11', symbol: 'SMAC11.SA' },
  { name: 'SMAL', symbol: 'SMAL' },
  { name: 'SMAL11', symbol: 'SMAL11.SA' },
  { name: 'SMFT3', symbol: 'SMFT3.SA' },
  { name: 'SMLL', symbol: 'SMLL' },
  { name: 'SMTO3', symbol: 'SMTO3.SA' },
  { name: 'SNCI11', symbol: 'SNCI11.SA' },
  { name: 'SNFF11', symbol: 'SNFF11.SA' },
  { name: 'SNSY5', symbol: 'SNSY5.SA' },
  { name: 'SOJA3', symbol: 'SOJA3.SA' },
  { name: 'SOMA3', symbol: 'SOMA3.SA' },
  { name: 'SOND5', symbol: 'SOND5.SA' },
  { name: 'SOND6', symbol: 'SOND6.SA' },
  { name: 'SPTW11', symbol: 'SPTW11.SA' },
  { name: 'SQIA3', symbol: 'SQIA3.SA' },
  { name: 'SSFO34', symbol: 'SSFO34.SA' },
  { name: 'STBP3', symbol: 'STBP3.SA' },
  { name: 'SULA11', symbol: 'SULA11.SA' },
  { name: 'SULA3', symbol: 'SULA3.SA' },
  { name: 'SULA4', symbol: 'SULA4.SA' },
  { name: 'SUZB3', symbol: 'SUZB3.SA' },
  { name: 'SYNE3', symbol: 'SYNE3.SA' },
  { name: 'TAEE11', symbol: 'TAEE11.SA' },
  { name: 'TAEE3', symbol: 'TAEE3.SA' },
  { name: 'TAEE4', symbol: 'TAEE4.SA' },
  { name: 'TAKP34', symbol: 'TAKP34.SA' },
  { name: 'TASA3', symbol: 'TASA3.SA' },
  { name: 'TASA4', symbol: 'TASA4.SA' },
  { name: 'TCNO3', symbol: 'TCNO3.SA' },
  { name: 'TCNO4', symbol: 'TCNO4.SA' },
  { name: 'TCSA3', symbol: 'TCSA3.SA' },
  { name: 'TECB', symbol: 'TECB' },
  { name: 'TECB11', symbol: 'TECB11.SA' },
  { name: 'TECN3', symbol: 'TECN3.SA' },
  { name: 'TEKA4', symbol: 'TEKA4.SA' },
  { name: 'TELB3', symbol: 'TELB3.SA' },
  { name: 'TELB4', symbol: 'TELB4.SA' },
  { name: 'TEND3', symbol: 'TEND3.SA' },
  { name: 'TEPP11', symbol: 'TEPP11.SA' },
  { name: 'TEQI11', symbol: 'TEQI11.SA' },
  { name: 'TEXA34', symbol: 'TEXA34.SA' },
  { name: 'TFCO4', symbol: 'TFCO4.SA' },
  { name: 'TGAR11', symbol: 'TGAR11.SA' },
  { name: 'TGMA3', symbol: 'TGMA3.SA' },
  { name: 'TGTB34', symbol: 'TGTB34.SA' },
  { name: 'THRA11', symbol: 'THRA11.SA' },
  { name: 'TIMS3', symbol: 'TIMS3.SA' },
  { name: 'TMCO34', symbol: 'TMCO34.SA' },
  { name: 'TMOS34', symbol: 'TMOS34.SA' },
  { name: 'TORD11', symbol: 'TORD11.SA' },
  { name: 'TOTS3', symbol: 'TOTS3.SA' },
  { name: 'TPIS3', symbol: 'TPIS3.SA' },
  { name: 'TRAD3', symbol: 'TRAD3.SA' },
  { name: 'TRIG', symbol: 'TRIG' },
  { name: 'TRIS3', symbol: 'TRIS3.SA' },
  { name: 'TRNT11', symbol: 'TRNT11.SA' },
  { name: 'TRPL3', symbol: 'TRPL3.SA' },
  { name: 'TRPL4', symbol: 'TRPL4.SA' },
  { name: 'TRXB11', symbol: 'TRXB11.SA' },
  { name: 'TRXF11', symbol: 'TRXF11.SA' },
  { name: 'TSER11', symbol: 'TSER11.SA' },
  { name: 'TSLA34', symbol: 'TSLA34.SA' },
  { name: 'TSMC34', symbol: 'TSMC34.SA' },
  { name: 'TTEN3', symbol: 'TTEN3.SA' },
  { name: 'TUPY3', symbol: 'TUPY3.SA' },
  { name: 'TWTR34', symbol: 'TWTR34.SA' },
  { name: 'TXRX3', symbol: 'TXRX3.SA' },
  { name: 'TXRX4', symbol: 'TXRX4.SA' },
  { name: 'U1BE34', symbol: 'U1BE34.SA' },
  { name: 'UCAS3', symbol: 'UCAS3.SA' },
  { name: 'UGPA3', symbol: 'UGPA3.SA' },
  { name: 'ULEV34', symbol: 'ULEV34.SA' },
  { name: 'UNHH34', symbol: 'UNHH34.SA' },
  { name: 'UNIP3', symbol: 'UNIP3.SA' },
  { name: 'UNIP5', symbol: 'UNIP5.SA' },
  { name: 'UNIP6', symbol: 'UNIP6.SA' },
  { name: 'UPAC34', symbol: 'UPAC34.SA' },
  { name: 'UPSS34', symbol: 'UPSS34.SA' },
  { name: 'URPR11', symbol: 'URPR11.SA' },
  { name: 'USBC34', symbol: 'USBC34.SA' },
  { name: 'USIM3', symbol: 'USIM3.SA' },
  { name: 'USIM5', symbol: 'USIM5.SA' },
  { name: 'USIM6', symbol: 'USIM6.SA' },
  { name: 'VALE3', symbol: 'VALE3.SA' },
  { name: 'VAMO3', symbol: 'VAMO3.SA' },
  { name: 'VBBR3', symbol: 'VBBR3.SA' },
  { name: 'VCJR11', symbol: 'VCJR11.SA' },
  { name: 'VCRR11', symbol: 'VCRR11.SA' },
  { name: 'VERZ34', symbol: 'VERZ34.SA' },
  { name: 'VGHF11', symbol: 'VGHF11.SA' },
  { name: 'VGIA11', symbol: 'VGIA11.SA' },
  { name: 'VGIP11', symbol: 'VGIP11.SA' },
  { name: 'VGIR11', symbol: 'VGIR11.SA' },
  { name: 'VIFI11', symbol: 'VIFI11.SA' },
  { name: 'VIGT11', symbol: 'VIGT11.SA' },
  { name: 'VIIA3', symbol: 'VIIA3.SA' },
  { name: 'VILG11', symbol: 'VILG11.SA' },
  { name: 'VINO11', symbol: 'VINO11.SA' },
  { name: 'VISA34', symbol: 'VISA34.SA' },
  { name: 'VISC11', symbol: 'VISC11.SA' },
  { name: 'VITT3', symbol: 'VITT3.SA' },
  { name: 'VIUR11', symbol: 'VIUR11.SA' },
  { name: 'VIVA3', symbol: 'VIVA3.SA' },
  { name: 'VIVR3', symbol: 'VIVR3.SA' },
  { name: 'VIVT3', symbol: 'VIVT3.SA' },
  { name: 'VLID3', symbol: 'VLID3.SA' },
  { name: 'VLOL11', symbol: 'VLOL11.SA' },
  { name: 'VOTS11', symbol: 'VOTS11.SA' },
  { name: 'VRTA11', symbol: 'VRTA11.SA' },
  { name: 'VRTX34', symbol: 'VRTX34.SA' },
  { name: 'VSEC11', symbol: 'VSEC11.SA' },
  { name: 'VSHO11', symbol: 'VSHO11.SA' },
  { name: 'VSLH11', symbol: 'VSLH11.SA' },
  { name: 'VTLT11', symbol: 'VTLT11.SA' },
  { name: 'VULC3', symbol: 'VULC3.SA' },
  { name: 'VVEO3', symbol: 'VVEO3.SA' },
  { name: 'VVPR11', symbol: 'VVPR11.SA' },
  { name: 'VXXV11', symbol: 'VXXV11.SA' },
  { name: 'W1DC34', symbol: 'W1DC34.SA' },
  { name: 'WALM34', symbol: 'WALM34.SA' },
  { name: 'WEGE3', symbol: 'WEGE3.SA' },
  { name: 'WEST3', symbol: 'WEST3.SA' },
  { name: 'WFCO34', symbol: 'WFCO34.SA' },
  { name: 'WHRL3', symbol: 'WHRL3.SA' },
  { name: 'WHRL4', symbol: 'WHRL4.SA' },
  { name: 'WIZS3', symbol: 'WIZS3.SA' },
  { name: 'WLMM3', symbol: 'WLMM3.SA' },
  { name: 'WLMM4', symbol: 'WLMM4.SA' },
  { name: 'WPLZ11', symbol: 'WPLZ11.SA' },
  { name: 'WTSP11B', symbol: 'WTSP11B.SA' },
  { name: 'XBOV', symbol: 'XBOV.SA' },
  { name: 'XBOV11', symbol: 'XBOV11.SA' },
  { name: 'XFIX11', symbol: 'XFIX11.SA' },
  { name: 'XINA11', symbol: 'XINA11.SA' },
  { name: 'XMAL11', symbol: 'XMAL11.SA' },
  { name: 'XPBR31', symbol: 'XPBR31.SA' },
  { name: 'XPCA11', symbol: 'XPCA11.SA' },
  { name: 'XPCI11', symbol: 'XPCI11.SA' },
  { name: 'XPCM11', symbol: 'XPCM11.SA' },
  { name: 'XPHT11', symbol: 'XPHT11.SA' },
  { name: 'XPHT12', symbol: 'XPHT12.SA' },
  { name: 'XPID11', symbol: 'XPID11.SA' },
  { name: 'XPIE11', symbol: 'XPIE11.SA' },
  { name: 'XPIN11', symbol: 'XPIN11.SA' },
  { name: 'XPLG11', symbol: 'XPLG11.SA' },
  { name: 'XPML11', symbol: 'XPML11.SA' },
  { name: 'XPPR11', symbol: 'XPPR11.SA' },
  { name: 'XPSF11', symbol: 'XPSF11.SA' },
  { name: 'XTED11', symbol: 'XTED11.SA' },
  { name: 'YDUQ3', symbol: 'YDUQ3.SA' },
  { name: 'ZIFI11', symbol: 'ZIFI11.SA' },
];
